import { useRef, useState } from 'react';

const TOGGLE_DELAY = 3000;

export const useCopyToClipboard = () => {
  const [isCopied, setIsCopied] = useState(false);
  const timeout = useRef<null | NodeJS.Timeout>(null);

  const isClipboardAvailable = 'clipboard' in navigator;

  const toggleAfterDelay = (delay: number) => {
    if (timeout.current) {
      clearTimeout(timeout.current);
    }
    timeout.current = setTimeout(() => {
      setIsCopied(false);
    }, delay);
  };

  const copyWithExecCommand = (value: string) => {
    const element = document.createElement('textarea');

    element.setAttribute('readonly', '');
    element.style.clipPath = 'inset(50%)';
    element.style.position = 'absolute';
    element.style.left = '-9999px';

    element.textContent = value;
    document.body.appendChild(element);

    element.select();
    const isCopied = document.execCommand('copy');

    document.body.removeChild(element);

    setIsCopied(isCopied);
    toggleAfterDelay(TOGGLE_DELAY);

    return isCopied;
  };

  const copy = async (value: string) => {
    if (isCopied) return;

    try {
      if (isClipboardAvailable) {
        await navigator.clipboard.writeText(value);
        setIsCopied(true);
        toggleAfterDelay(TOGGLE_DELAY);
        return true;
      } else {
        throw new Error('Clipboard API is not available');
      }
    } catch (error) {
      return copyWithExecCommand(value);
    }
  };

  return {
    copy,
    isCopied,
  };
};
